"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// please do not delete React, as without it other projects could not be compiled: ReferenceError: React is not defined
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/styles");
const material_1 = require("@mui/material");
const Utils_1 = __importDefault(require("./Utils"));
const styles = {
    root: {
        height: '100%',
        overflow: 'hidden',
    },
    overflowAuto: {
        overflow: 'auto',
    },
};
class TabContent extends react_1.default.Component {
    render() {
        const { classes } = this.props;
        return react_1.default.createElement(material_1.Grid, { item: true, className: Utils_1.default.clsx(classes.root, this.props.overflow === 'auto' ? classes.overflowAuto : '') }, this.props.children);
    }
}
/** @type {typeof TabContent} */
const _export = (0, styles_1.withStyles)(styles)(TabContent);
exports.default = _export;
